import ProjectCardsFactory from '@/components/projects/cards/factory/ProjectCardsFactory';
import { CourseTypeFilterValue } from '@/components/projects/carousel/filters/CourseTypeFilter';
import useWinners from '@/data/hook/hackathon/useWinners';
import Hackathon from '@/models/Hackathon';
import { twMerge } from 'tailwind-merge';

type RankingByCourseProps = {
  hackathon: Hackathon;
  courseType: CourseTypeFilterValue;
};

export default function PodiumByCourse({
  hackathon,
  courseType,
}: RankingByCourseProps) {
  const { winnersByCategory, invalidate } = useWinners(hackathon);

  const winners = winnersByCategory[courseType];
  const classNames = ['', 'scale-90', 'scale-90 top-2'];
  return (
    <ul className="w-full relative flex md:justify-center items-center gap-1 overflow-x-scroll md:overflow-visible scrollbar-hide snap-x snap-mandatory">
      {winners?.map(winner => (
        <ProjectCardsFactory
          mode="podium"
          key={winner.id}
          rank={winner.rank}
          onMutate={invalidate}
          className={{
            base: twMerge('w-60 min-w-60', classNames[winner.rank - 1]),
          }}
          project={winner.project}
        />
      ))}
    </ul>
  );
}
